let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9X4yo")).then(() => parcelRequire('kxF7S'));